import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';

const REMOVE_PRODUCT_PRICING = gql`
  mutation removeProductPricingOption($productPricingOptionId: ID!) {
    removeProductPricingOption(productPricingOptionId: $productPricingOptionId) {
      id
      pricingOptions {
        id
        name
        label
        rateMode
        rate
        percentageMinimum
        percentageMaximum
        coverageParameters {
          id
          cacheId
          name
          type
          value
        }
      }
    }
  }
`;

export default function useRemoveCommission({ productPricingOptionId, onCompleted = () => {}, onError = () => {} }) {
  const [remove, { loading, error }] = useMutation(REMOVE_PRODUCT_PRICING, {
    variables: { productPricingOptionId },
    onCompleted,
    onError
  });

  return {
    removePricing: remove,
    loading,
    error
  };
}
